import React, {Component} from 'react';
import {Route, Routes} from 'react-router-dom'
import {withTranslation} from 'react-i18next';
import News from "./News";

class App extends Component {
  render() {
    return (
      <Routes>

        <Route path={'*'} element={<News />} />
      </Routes>
    );
  }
}

export default withTranslation('remote')(App);